import React from 'react';
import PlayerInfoTitle from '@smart-tv/components/player/player-info-title';
import PlayerInfo from '../../player-info';
import PlayerInfoSubtitle from '../../player-info-subtitle';
import useStream from '../../_hooks/use-stream';
import { LiveTvChannel, StreamType } from '@smart-tv/typings/content';

interface LivePlayerScreenInfoProps {
  selectedChannel?: LiveTvChannel;
}

export const LivePlayerScreenInfo: React.FC<LivePlayerScreenInfoProps> = ({ selectedChannel }) => {
  const { streamType } = useStream();

  const currentProgram = selectedChannel?.currentProgram;
  const statusText = streamType === StreamType.LiveStream ? 'Afspiller nu' : 'Afspilles forskudt';

  return (
    <PlayerInfo>
      <PlayerInfoTitle>{currentProgram?.title}</PlayerInfoTitle>
      <PlayerInfoSubtitle>
        {statusText} • {selectedChannel?.name}
      </PlayerInfoSubtitle>
    </PlayerInfo>
  );
};

export default React.memo(LivePlayerScreenInfo);
